import focusSource from 'ally.js/src/style/focus-source';

focusSource();



// WEBPACK FOOTER //
// ./client/src/site__scf001/utilities/a11y__focus.js